import React from "react";
import {View, Text} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import PrintDocumentDiscount from "./printDocumentDiscount";

const PrintDocumentDiscountsList = (props) => {
  const {styles, discountSections, fabricatorSettings} = props;

  return (
    <View style={styles.discounts}>
      {discountSections.map((discountSection, discountSectionIndex) => {
        if (!discountSection.discounts.some(discount => discount.selected && !(discount.isRidged && !discount.specialVisible))) {
          return null
        }
        return (
          <View style={styles.discountSection} wrap={false} key={discountSectionIndex}>
            <Text style={styles.subPartTitle}>{discountSection.name}</Text>
            {discountSection.discounts.map((discount, discountIndex) => {
              return discount.selected && !discount.isSubTotal && !(discount.isRidged && !discount.specialVisible) ? (
                <PrintDocumentDiscount discount={discount}
                                       key={discountIndex}
                                       discountSections={discountSections}
                                       discountSection={discountSection}
                                       fabricatorSettings={fabricatorSettings}
                                       styles={styles}/>
              ) : null
            })}
          </View>
        )
      })}
    </View>
  )
};

PrintDocumentDiscountsList.propTypes = {
  discountSections: PropTypes.array.isRequired,
  fabricatorSettings: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentDiscountsList
